/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, {
  useRef,
  useCallback,
  useState,
  Fragment,
  useEffect
} from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useHistory } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import { CircularProgress } from "@material-ui/core";
import DefaultImg from "../../assets/images/default-picture.png";
import { getConsultHistoryList } from "../../apiRoutes";
import Label from "../../components/label";

import { getFormattedDate } from "../../utils/dateTimeHelper";

function createData(_id, consultID, type, date, patient, patientImg) {
  return {
    _id,
    consultID,
    type,
    date,
    patient,
    patientImg
  };
}

export default function MyAppointmentTableSticky(props) {
  const history = useHistory(); // go to other page with or without data
  const observer = useRef(); // to check it is the last element or not - if it is last element then call an API
  const [pageNo, setPageNumber] = useState(1); // just set page number if needed in future.
  const [nextPage, setNextPage] = useState(false); // set next page if there is more data
  const [loading, setLoading] = useState(true); // loading variable used to reduce multiple API calls
  const [progressBar, setProgressBar] = useState(false); // progress bar hide and show
  const [limit, setLimit] = useState(8); // limit is fixed but if we need to change in future then change it here
  const [skip, setSkip] = useState(0); // set Skip page
  const [noMoreData, setNoMoreData] = useState(false); // no data found block hide-show

  // Column Names - if you want to add an column then add id and label here - also take care of createData function (need to pass data)
  const columns = [
    {
      id: "consultID",
      label: "Consult ID"
    },
    {
      id: "type",
      label: "Type"
    },
    {
      id: "date",
      label: "Date"
    },
    {
      id: "patient",
      label: "Patient"
    }
  ];

  // Data to be appended
  const [rows, setRows] = useState([]); // setting rows
  const [appendRows, setAppendRows] = useState([]); // not used for now (if needed in future)

  /*
   * Go to consult history page - need to pass _id to get the data on page
   */
  const goTo = (event, no) => {
    history.push(appRoutes.consultHistoryView + "/" + no, { _id: no });
  };

  /*
   * Check last element is visible or not on scroll
   */
  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data) {
        if (data[0].isIntersecting && nextPage && loading) {
          setLoading(false);
          if (loading) {
            let skipCalculate = limit * pageNo,
              updatePage = pageNo + 1;
            setPageNumber(pageNo => pageNo + 1);
            setSkip(skipCalculate);
            getConsultHistory(limit, skipCalculate, updatePage);
          }
          setTimeout(() => {
            setLoading(true);
          }, 2000);
        }
      }
    });
    if (node) observer.current.observe(node);
  });

  /*
   * Main function to call an API
   * Pass parameters compulusry (limit, skipPage, currentPage) to calculate pagination
   */

  const getConsultHistory = useCallback(
    (limitPage, skipPage, pageNoUpdated) => {
      console.log("getConsultHistoryList", getConsultHistoryList);
      let apiCallParam = {
        reqType: "GET",
        reqURL: getConsultHistoryList,
        dataObj: {},
        params: {
          limit: limitPage,
          skip: skipPage,
          startDate: props.startDate,
          endDate: new Date(
            new Date(props.endDate).getFullYear(),
            new Date(props.endDate).getMonth(),
            new Date(props.endDate).getDate() + 1,
            0,
            0,
            0
          ).toISOString(),
          ageStart: props.ageRange[0],
          ageEnd: props.ageRange[1],
          gender: props.gender,
          state: props.state
        },
        headers: {},
        successCallback: res => {
          // calculate is there any next page or not ?
          let consultNotecount = res.data.data.aggregateData.length
            ? res.data.data.aggregateData[0].consultCount
            : 0;
          let currentRowCount = consultNotecount - pageNoUpdated * limitPage;
          if (currentRowCount > 0) {
            setNextPage(true);
          } else {
            setNextPage(false);
            setNoMoreData(true);
            setProgressBar(false);
          }

          // set the data
          let consultData = [];
          res.data.data.consultData.map((value, index) => {
            if(value.patientId) {
              consultData.push(
                createData(
                  value._id,
                  value.appointmentId,
                  value.consultNature
                    ? value.consultNature
                    : value.consultId ? value.consultId.consultName : '-',
                  getFormattedDate(value.createdAt),
                  value.patientId.firstName + " " + value.patientId.lastName,
                  value.patientId.profilePic.original
                    ? value.patientId.profilePic.original
                    : "../../../assets/images/default-picture.png"
                )
              );
            }
          });
          if (skipPage === 0) {
            setRows(consultData);
          } else {
            setRows(prev => prev.concat(consultData));
          }

          // convert milisecond to 0min 0sec or 0mins 0secs
          let x = parseInt(
              res.data.data.aggregateData.length
                ? res.data.data.aggregateData[0].avgDuration
                : 0
            ),
            totalSeconds = x / 1000,
            minutes = parseInt(totalSeconds / 60),
            seconds = parseInt(totalSeconds % 60),
            minValue = "",
            minValue1 = "";
          if (minutes == 0 || minutes == 1) {
            minValue = "min";
          } else {
            minValue = "mins";
          }
          if (seconds == 0 || seconds == 1) {
            minValue1 = "sec";
          } else {
            minValue1 = "secs";
          }

          // set Consulations / Avg. Duration of Consult / Earnings data from class component
          let earningData = {
            totalConsultation: res.data.data.aggregateData.length
              ? res.data.data.aggregateData[0].consultCount.toString()
              : "0",
            duration: minutes + minValue + " " + seconds + minValue1,
            earnings:
              "$" +
              (res.data.data.aggregateData.length
                ? res.data.data.aggregateData[0].totalAmount.toFixed(2)
                : "0")
          };
          props.updateAggregateData(earningData);
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      };
      props.makeAPICall(apiCallParam);
    }
  );

  /*
   * Watch on filter  by dates
   */
  useEffect(() => {
    resetPagination();
    setRows([]);
    getConsultHistory(limit, 0, 1);
  }, [props.filterByDateCall]);

  /*
   * Reset pagination
   */
  const resetPagination = () => {
    setPageNumber(1);
    setNextPage(false);
    setLoading(true);
    setProgressBar(true);
    setSkip(0);
    setNoMoreData(false);
  };

  return (
    <Fragment>
      <Paper className="w-100 consult-history-list-parent">
        <TableContainer className="table-max-height primary-table-color constult-history-table">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              {/* Loop on Column name  */}
              <TableRow>
                {columns.map(column => (
                  <TableCell key={column.id} align={column.align}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Loop over the data (createData function) */}
              {rows.map((row, index) => {
                /*
                 * If it is last element then take the referent to call an API Else print another block
                 */
                if (rows.length === index + 1) {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      ref={lastElementRef}
                      hover
                      key={row.consultID}
                      onClick={event => goTo(event, row._id)}
                    >
                      <TableCell
                        className={
                          (noMoreData && !rows.length) ||
                          (noMoreData && rows.length === limit) ||
                          (noMoreData && pageNo > 1)
                            ? "primary-color"
                            : "primary-color border-bottom-0"
                        }
                      >
                        {row.consultID}
                      </TableCell>

                      <TableCell
                        className={
                          (noMoreData && !rows.length) ||
                          (noMoreData && rows.length === limit) ||
                          (noMoreData && pageNo > 1)
                            ? ""
                            : "border-bottom-0"
                        }
                      >
                        {row.type}
                      </TableCell>

                      <TableCell
                        className={
                          (noMoreData && !rows.length) ||
                          (noMoreData && rows.length === limit) ||
                          (noMoreData && pageNo > 1)
                            ? ""
                            : "border-bottom-0"
                        }
                      >
                        {row.date}
                      </TableCell>

                      <TableCell
                        className={
                          (noMoreData && !rows.length) ||
                          (noMoreData && rows.length === limit) ||
                          (noMoreData && pageNo > 1)
                            ? "ic-patient-pic"
                            : "border-bottom-0 ic-patient-pic"
                        }
                      >
                        <img
                          src={row.patientImg ? row.patientImg : DefaultImg}
                          alt="user-ic-patient"
                          className="patient-image rounded-circle border mb-1"
                        />
                        <br /> <span className="ml-1 pt-1">{row.patient}</span>
                      </TableCell>
                    </TableRow>
                  );
                } else {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      hover
                      key={row.consultID}
                      onClick={event => goTo(event, row._id)}
                    >
                      <TableCell className="primary-color">
                        {row.consultID}
                      </TableCell>

                      <TableCell>{row.type}</TableCell>

                      <TableCell>{row.date}</TableCell>

                      <TableCell className="ic-patient-pic">
                        <img
                          src={row.patientImg ? row.patientImg : DefaultImg}
                          alt="user-ic-patient"
                          className="patient-image rounded-circle border mb-1"
                        />
                        <br /> <span className="ml-1 pt-1">{row.patient}</span>
                      </TableCell>
                    </TableRow>
                  );
                }
              })}

              {/*
               * Progress bar on loading of APIs
               */}

              <TableRow className={progressBar ? "" : "d-none"}>
                <TableCell
                  colSpan={7}
                  className="text-center progress-bar-center"
                >
                  <CircularProgress disableShrink className="primary-loader" />
                </TableCell>
              </TableRow>

              {/*
               * No data fount if there are no data array in API
               */}

              <TableRow
                className={
                  (noMoreData && !rows.length) ||
                  (noMoreData && rows.length === limit) ||
                  (noMoreData && pageNo > 1)
                    ? ""
                    : "d-none"
                }
              >
                <TableCell
                  colSpan={7}
                  className="text-center progress-bar-center border-bottom-0 no-data-found"
                >
                  <Label title="No data found" />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Fragment>
  );
}
